import { createCustomer, fetchWallet } from '../../clients/vouchermatic'
import { Membership } from '../../types'

class VouchermaticRepository {

    async fetchWallet(membershipId: string): Promise<string> {
        const data = await fetchWallet(membershipId)
        return data
    }

    async createCustomer(membership?: Membership): Promise<string> {
        const data = await createCustomer(membership)
        return data
    }

}

export default VouchermaticRepository